// @ts-nocheck

export const QR_CODE_LENGTH = 6;

export const isQRCodeValid = (value: string | null, options: { nullable?: boolean } = { nullable: true }) => {
  const { nullable } = options;
  const valueLength = value?.length ?? 0;
  const condition = valueLength <= QR_CODE_LENGTH && /[a-zA-Z0-9]+/.test(value?.charAt(valueLength - 1) ?? '');

  if (nullable) {
    return !value || condition;
  }
  return condition;
};
